export default __webpack_public_path__ + "static/char-s-11-chs-f65ae9322f801a6247d191a68880b2a1.png";